import React, { Suspense } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { ScrollToTop } from './components/ScrollToTop';
import  LoadingIndiacator  from './components/LoadingIndicator';

// Lazy load all page components
const Home = React.lazy(() => import('./pages/Home'));
const Ifsc = React.lazy(() => import('./pages/Ifsc'));
const Bank = React.lazy(() => import('./pages/Bank'));
const About = React.lazy(() => import('./pages/About'));
const NearBy = React.lazy(() => import('./pages/NearBy'));
const Search = React.lazy(() => import('./pages/Search'));
const NotFound = React.lazy(() => import('./pages/NotFound'));
const Directory = React.lazy(() => import('./pages/Directory'));
const State = React.lazy(() => import('./pages/State'));
const District = React.lazy(() => import('./pages/District'));
const City = React.lazy(() => import('./pages/City'));
const Branch = React.lazy(() => import('./pages/Branch'));
const IfscPage = React.lazy(() => import('./pages/IfscPage'));

const App: React.FC = () => {
const router = createBrowserRouter([
  {
    path: "/",
    element: <Suspense fallback={<LoadingIndiacator />}><Home /></Suspense>,
    errorElement: <NotFound />
  },
  // Dynamic bank routes without /bank/ prefix
  {
    path: "/:bankName/",
    element: <Suspense fallback={<LoadingIndiacator />}><State /></Suspense>,
    errorElement: <NotFound />
  },
  {
    path: "/:bankName/:stateName/",
    element: <Suspense fallback={<LoadingIndiacator />}><District /></Suspense>,
    errorElement: <NotFound />
  },
  {
    path: "/:bankName/:stateName/:districtName/",
    element: <Suspense fallback={<LoadingIndiacator />}><City /></Suspense>,
    errorElement: <NotFound />
  },
  {
    path: "/:bankName/:stateName/:districtName/:branchName/",
    element: <Suspense fallback={<LoadingIndiacator />}><Branch /></Suspense>,
    errorElement: <NotFound />
  },
  // Other routes remain unchanged
  {
    path: "/bank/",
    element: <Suspense fallback={<LoadingIndiacator />}><Bank /></Suspense>,
    errorElement: <NotFound />
  },
  {
    path: "/about/",
    element: <Suspense fallback={<LoadingIndiacator />}><About /></Suspense>,
    errorElement: <NotFound />
  },
  {
    path: "/ifsc/",
    element: <Suspense fallback={<LoadingIndiacator />}><Ifsc /></Suspense>,
    errorElement: <NotFound />
  },
  {
    path: "/nearby/",
    element: <Suspense fallback={<LoadingIndiacator />}><NearBy /></Suspense>,
    errorElement: <NotFound />
  },
  {
    path: "/directory/",
    element: <Suspense fallback={<LoadingIndiacator />}><Directory /></Suspense>,
    errorElement: <NotFound />
  },
  {
    path: "/search/",
    element: <Suspense fallback={<LoadingIndiacator />}><Search /></Suspense>,
    errorElement: <NotFound />
  },
  {
    path: "/ifsc/:ifsc/",
    element: <Suspense fallback={<LoadingIndiacator />}><IfscPage /></Suspense>,
    errorElement: <NotFound />
  },
  // Catch-all for 404
  {
    path: "*",
    element: <NotFound />
  }
]);

  return (
    <React.StrictMode>
      <div className={`min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-300`}>
        <ScrollToTop/>
        <RouterProvider router={router} />
        <Toaster 
          position="bottom-right" 
          toastOptions={{
            className: 'dark:bg-gray-700 dark:text-white',
          }}
        />
      </div>
    </React.StrictMode>
  );
};

export default App;